<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-celadon mr-3 shrink-0" viewBox="0 0 24 24" fill="none">
    <path d="M16.5 6.5L9 14c-1.25 1.25-1.25 3.25 0 4.5s3.25 1.25 4.5 0l7.5-7.5c2-2 2-5.25 0-7.25s-5.25-2-7.25 0L5 15" stroke-width="2" fill="none"/>
  </svg>
</template>
